import styled from "styled-components";

// To prevent bugs like BUG #1810621 we should add the scrollbar width to the drawer width
const DRAWER_WIDTH = 375;
const SCROLLBAR_WIDTH = 17; // varies in each browser but none should be larger than 17px

export const DrawerBodyDefaultBox = styled.div<{zIndex: number}>`
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 0;
  width: ${DRAWER_WIDTH + SCROLLBAR_WIDTH}px;
  height: 100%;
  margin-right: -${DRAWER_WIDTH + SCROLLBAR_WIDTH}px;
  background: ${props => props.theme.colors.navBackground};
  transition: transform 0.25s ease;
  z-index: ${props => props.zIndex};

  @media ${({theme}) =>  theme.mediaQuery.sAndBelow} {
    padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
    width: 100vw;
    margin-right: -100vw;
  }

  &.open {
    transform: translateX(-100%);

    &::before {
      content: "";
      position: absolute;
      width: 50px;
      height: 100%;
      left: -50px;
      background: linear-gradient(90deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5));
      pointer-events: none;
    }
  }
`;
